import { render, staticRenderFns } from "./AccountingDetail.vue?vue&type=template&id=ed5a4b96&scoped=true"
import script from "./AccountingDetail.vue?vue&type=script&lang=js"
export * from "./AccountingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5a4b96",
  null
  
)

export default component.exports